import ajax from '../../common/services/httpService'
import { getDefaultDeviceActionFlags } from '../../devices/utils/deviceFlagUtils'
const BASE_URL = 'deviceManager'

/**
 * @param {Object} actionFlags
 * @param {String} actionFlags.id
 * @param {Boolean} actionFlags.is_update
 * @param {Boolean} actionFlags.is_restart
 * @param {Object} actionFlags.user_flags
 * @param {Object} actionFlags.sensor_flags
 * @param {String} deviceCode
 * @returns {Promise<Number>} Num of records updated
 */
function buildActionFlagsPayload(actionFlags) {
	if (!actionFlags?.id) {
		throw new Error('Device id is required')
	}
	return {
		id: actionFlags.id,
		type: 'user',
		is_update: !!actionFlags.is_update,
		is_restart: !!actionFlags.is_restart,
		user_flags: JSON.parse(JSON.stringify(actionFlags.user_flags || {})),
		sensor_flags: JSON.parse(JSON.stringify(actionFlags.sensor_flags || {})),
	}
}

async function setActionFlags(actionFlags) {
	const payload = buildActionFlagsPayload(actionFlags)
	const res = await ajax.put(`${BASE_URL}/actionFlags`, { actionFlags: payload })
	if (!res) {
		throw new Error('Failed to update device flags')
	}
	return res
}

/**
 * @param {Object} actionFlags
 * @param {String} actionFlags.id
 * @param {Boolean} actionFlags.is_update
 * @param {Boolean} actionFlags.is_restart
 * @param {Object} actionFlags.user_flags
 * @param {Object} actionFlags.sensor_flags
 * @param {String} deviceCode
 * @returns {Promise<Number>} Num of records updated
 */
async function setActionFlagsBySiteId(actionFlags, siteId) {
	const res = await ajax.put(`${BASE_URL}/actionFlags/${siteId}`, { actionFlags })
	return res
}

function getDefaultActionFlags() {
	const { user_flags, sensor_flags } = getDefaultDeviceActionFlags()
	return {
		is_update: false,
		is_restart: false,
		user_flags,
		sensor_flags,
	}
}

export default {
	setActionFlags,
	setActionFlagsBySiteId,
	getDefaultActionFlags
}
